import {
  useScan,
  useScanComponents,
  useScanVulnerabilities
} from '../hooks/useScans';

import { BaseReport } from '../components/BaseReport';

interface ScanViewReportProps {
  onNavigate?: (route: string, params?: any) => void;
  scanId?: number;
}

export function ScanViewReport({ onNavigate, scanId }: ScanViewReportProps) {
  const { data:scanData,refetch } = useScan(scanId);
  const { data:scanComponents } = useScanComponents(scanId);
  const {data:scanVulnerabilities} = useScanVulnerabilities(scanId);


  return (
    <BaseReport
      onNavigate={onNavigate}
      reportType="scan"
      onRefresh={refetch}
      scanData={{
        details: scanData,
        components: scanComponents,
        vulnerabilities: scanVulnerabilities,
      }}
    />
  );
}
